import React, { useState, useEffect, useRef } from "react";
import moment from "moment-timezone";
import "./CountdownTimer.css"; // External CSS for styling
import clientConfig from "../../env";
import axios from "axios";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { getNextWeekEventList } from "../Events/EventList";

const CountdownTimer = () => {

  const dispatch = useDispatch();
  const lastRolloverRef = useRef(null);
  const userId = useSelector((state) => state.user.userId);
  const currentEventDetail = useSelector(
    (state) => state.events.currentEventDetail
  );

  const getTargetTime = () => {
    const now = moment().tz("America/New_York");
    let tuesday = moment()
      .tz("America/New_York")
      .day(2)
      .hour(10)
      .minute(0)
      .second(0)
      .millisecond(0);
    if (now.isAfter(tuesday.clone().add(1, "hour"))) {
      // Past the 1 hour window, go to next Tuesday
      tuesday.add(1, "week");
    }
    return tuesday;
  };

  const getTimeRemaining = () => {
    const now = moment().tz("America/New_York");
    const target = getTargetTime();
    const inBonusHour = now.isBetween(target, target.clone().add(1, "hour"));
    const finalTarget = inBonusHour ? target.clone().add(1, "hour") : target;
    const duration = moment.duration(finalTarget.diff(now));

    return {
      days: String(Math.floor(duration.asDays())).padStart(2, "0"),
      hours: String(duration.hours()).padStart(2, "0"),
      minutes: String(duration.minutes()).padStart(2, "0"),
      seconds: String(duration.seconds()).padStart(2, "0"),
      isBonus: inBonusHour,
    };
  };

  const [timeLeft, setTimeLeft] = useState(getTimeRemaining());
  const [eventDetails, setEventDetails] = useState();

  useEffect(() => {
    getEventData();

    const interval = setInterval(() => {
      const now = moment().tz("America/New_York");
      const target = getTargetTime(now); // next upcoming Tuesday@10:00
      // Update UI countdown using same now
      setTimeLeft(getTimeRemaining(now));

      // Rollover when we reach or pass the target and we haven't rolled this target yet
      const targetKey = target.format("YYYY-MM-DD HH:mm");
      if (now.isSameOrAfter(target) && lastRolloverRef.current !== targetKey) {
        lastRolloverRef.current = targetKey;
        rollOverWeeklyEvents();
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [userId]);

  // useEffect(() => {
  //   getEventData();
  //   const interval = setInterval(() => {
  //     setTimeLeft(getTimeRemaining());
  //   }, 1000);
  //   return () => clearInterval(interval);
  // }, []);

  useEffect(() => {
    if (
      timeLeft.isBonus &&
      timeLeft.days === "00" &&
      timeLeft.hours === "00" &&
      timeLeft.minutes === "00" &&
      timeLeft.seconds === "00"
    ) {
      rollOverWeeklyEvents();
    }
  }, [timeLeft]);

  async function rollOverWeeklyEvents() {
    console.log("Rolling over weekly events...");
    try {
      const headers = {
        "Content-Type": `application/json`,
      };
      const response = await axios.post(
        `${clientConfig.siteUrl}wl/v1/rollover-events`,
        {},
        { headers: headers }
      );
      console.log(response);
      if(response.status === 200) {
        getEventData();
        const nextWeekEventList = await getNextWeekEventList(userId);
        console.log(nextWeekEventList);
        if (nextWeekEventList.data?.topics?.length){
          dispatch({
            type: "SET_NEXT_WEEK_EVENTS",
            payload: nextWeekEventList.data?.topics, // or fetched data
          });
        } else {
          dispatch({
            type: "SET_NEXT_WEEK_EVENTS",
            payload: [], // or fetched data
          });
        }
      }
    } catch(error) {
      console.error(error)
    }
  }

  const getEventData = async () => {
    const headers = {
      "Content-Type": `application/json`,
    };
    try {
      const response = await axios.get(
        `${clientConfig.siteUrl}wl/v1/get-event`,
        { headers: headers }
      );

      if (response.status === 200) {
        if (response.data.type === "success") {
          const details = JSON.parse(response.data.result);
          setEventDetails(details);
          if (details) {
            dispatch({
              type: "GET_CURRENT_WEEK_EVENT",
              payload: {
                ...details,
                eventDate: getTargetTime().format("YYYY-MM-DD"),
                eventTime: getTargetTime().tz("UTC").format("HH:mm:ss"),
              },
            });
          }
        } else {
          toast.error(response.data.message);
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    currentEventDetail && (
      <div className="countdown-wrapper">
        <h2 className="heading mb-4">Featured Event</h2>
        <h4 className="font-weight-bold">
          Join the Table : {currentEventDetail?.eventName}
        </h4>
        <p className="subheading font-weight-bold">
          {timeLeft.isBonus
            ? "Event has started. Time remaining:"
            : `${getTargetTime().format(
                "MMMM D, YYYY - dddd"
              )} @ ${getTargetTime().format("hh:mm A")} EST`}
        </p>

        <div className="countdown">
          <div className="time-box">
            <span className="time">{timeLeft.days}</span>
            <span className="label">Days</span>
          </div>
          <div className="time-box">
            <span className="time">{timeLeft.hours}</span>
            <span className="label">Hours</span>
          </div>
          <div className="time-box">
            <span className="time">{timeLeft.minutes}</span>
            <span className="label">Minutes</span>
          </div>
          <div className="time-box">
            <span className="time">{timeLeft.seconds}</span>
            <span className="label">Seconds</span>
          </div>
        </div>
      </div>
    )
  );
};

export default CountdownTimer;
